import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { OfflineManifest } from '@environments/environment.type';
import { Observable, from, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FileMetaCollection } from '../../apis/cas/generated';
import { IFileMetaProvider } from './IFileMetaProvider';

@Injectable({
  providedIn: 'root',
})
export class LocalFileMetaProvider implements IFileMetaProvider {
  manifestUrl = `${environment.offlineDataFolder}/offline-manifest.json`;

  getAllFileMetas(): Observable<FileMetaCollection> {
    const manifestUrlWithCacheBust = `${this.manifestUrl}?v=${Date.now()}`;

    return from(fetch(manifestUrlWithCacheBust)).pipe(
      switchMap((res) => {
        if (!res.ok) return throwError(() => new Error('Failed to load manifest'));
        return from(res.json());
      }),
      switchMap((manifest: OfflineManifest) => {
        const fileMetasUrl = `${environment.offlineDataFolder}/${manifest.fileMetas}`;
        return from(fetch(fileMetasUrl));
      }),
      switchMap((res) => {
        if (!res.ok) return throwError(() => new Error('Failed to load fileMetas'));
        return from(res.json());
      }),
      map((files) => ({ files })),
      catchError((err) => throwError(() => err)),
    );
  }
}
